<template>
  <nav>
    <div class="level-0">
      <navigation-item
        v-for="item of items"
        :key="item.label"
        :class="`xs:w-1/${items.length}`"
        :item="item"
        :active="highlights.includes(item.routeName)"
        :disabled="isRouterLinkEnabled(item) === false"
        @click="clickAction(item, 0)"
      >
      </navigation-item>
    </div>

    <transition name="dafe">
      <div v-if="subItems.length > 0" class="level-1">
        <navigation-item
          v-for="item of subItems"
          :key="item.label"
          :class="`xs:w-1/${subItems.length}`"
          :item="item"
          :active="highlights.includes(item.routeName)"
          :disabled="isRouterLinkEnabled(item) === false"
          @click="clickAction(item, 1)"
        >
        </navigation-item>
      </div>
    </transition>
    <ShareModal ref="shareDesign" />
  </nav>
</template>

<script>
import Capabilities from '../mixins/capabilities';
import { GETTER_PRODUCT_CHANGE_ENABLED } from '@/store/getters';
import { mapWritableState } from 'pinia';
import { useRouterStore } from '@/store-pinia/router';
import ShareModal from '@/components/ShareModal';
import { useNavigationStore } from '@/store-pinia/navigation';
import Redirect from '@/mixins/redirect';
import NavigationItem from './NavigationItem.vue';
import isMobile from '../../utils/is-mobile';
/*
 * The tracking mixin is required as onClick listeners of navigation items
 *  may execute calls to trackEvent of this component.
 */
import { TrackingMixin } from '@/mixins/gtm-tracking';

export default {
  name: 'Navigation',
  components: {
    NavigationItem,
    ShareModal
  },
  mixins: [Capabilities, Redirect, TrackingMixin],
  data() {
    return {
      highlights: []
    };
  },
  computed: {
    ...mapWritableState(useRouterStore, ['currentRoute']),
    ...mapWritableState(useNavigationStore, ['subItems']),
    ...mapWritableState(useNavigationStore, ['items'])
  },
  mounted() {
    this.$root.$on('reset-navigation', () => {
      this.highlights = [];
      this.subItems = [];
    });
    window.addEventListener('resize', this.loadNavigation);
    this.loadNavigation();
  },
  methods: {
    loadNavigation() {
      useNavigationStore().loadItems(isMobile() ? 'mobile' : 'desktop');
    },
    clickAction(item, level) {
      if (typeof item.onClick === 'function') {
        item.onClick(this);
        return;
      }
      this.highlights = this.highlights.slice(0, level);
      this.highlights.push(item.routeName);

      if (item.items && item.items.length > 0) {
        this.subItems = [...item.items];
      } else if (item.routeName) {
        this.currentRoute = item.routeName;
      }
    },
    isRouterLinkEnabled(item) {
      if (this.activePrintPlateSupports(item.element)) {
        return true;
      }

      // Check if the current item is Product change
      if ('product' === item.routeName) {
        return this.$store.getters[GETTER_PRODUCT_CHANGE_ENABLED];
      }

      if (!Object.prototype.hasOwnProperty.call(item, 'element')) {
        return true;
      }

      return null === item.element;
    }
  }
};
</script>

<style lang="scss" scoped>
nav {
  @apply pin-l z-1000  text-white;
}
div {
  @apply flex flex-no-shrink list-reset;
}
a {
  transition: all 0.1s ease-in-out;
}
.level-0 {
  @apply bg-sh-primary-darken-30;
}
.level-1 {
  @apply pin-t opacity-100 relative;
  background-image: linear-gradient(to bottom, #00446f 80%, #00273f);
  z-index: -1;
  top: 0;
  opacity: 1;
}

@screen md {
  nav {
    @apply w-32 absolute pin-t;
  }
  div {
    @apply flex-col;
  }
  a {
    @apply py-8 block;
  }
}

@screen xs {
  nav {
    @apply flex fixed pin-b w-full flex-col-reverse;
    div {
      @apply flex-row;
      &.level-0 {
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
      }
    }
  }
}

.dafe-enter-active,
.dafe-leave-active {
  transition: all 0.4s;
}
.dafe-enter, .dafe-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  top: 80px;
}
</style>
